import { faHourglass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@ui';
import { Booking } from 'components/EventCalendar/types';
import { useTranslation } from 'react-i18next';

interface Props {
    booking: Booking;
}

/** Participant cell: name and booking number on top, contact below — one line each, always in the same place. */
export const UserComponent = ({ booking }: Props) => {
    const { t } = useTranslation('bookings');

    const subline = [booking.user_email, booking.form_user_name].filter(Boolean).join(' · ');

    return (
        <div className="tw-flex tw-min-w-0 tw-flex-col">
            <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-2 tw-leading-5">
                <span
                    className={`tw-truncate tw-font-semibold ${booking.cancelled_at ? 'tw-text-accents-8 tw-line-through' : ''}`}
                    title={booking.user_name}
                >
                    {booking.user_name}
                </span>
                <span className="tw-shrink-0 tw-text-xs tw-tabular-nums tw-text-accents-6">#{booking.id}</span>
                {booking.is_waiting && (
                    <Tooltip tooltip={t('booking.list.tooltips.userWaiting')} className="tw-shrink-0 tw-text-accents-6">
                        <FontAwesomeIcon icon={faHourglass} size="xs" />
                    </Tooltip>
                )}
            </div>
            <span className="tw-truncate tw-text-xs tw-leading-4 tw-text-accents-6" title={subline}>
                {subline}
            </span>
        </div>
    );
};
